// Lib
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { getDashBoardStatistics } from 'modules/DashBoard/actions';
import { getNotifications } from 'actions/notifications';
import { UserTokenType } from 'types/global';

const useAppData = (userToken: UserTokenType) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (userToken) {
      dispatch(getNotifications());
      dispatch(getDashBoardStatistics());
    }
  }, [userToken, dispatch]);
};

export default useAppData;
